/**
 * Wire-level GitHub App role expected by vcs-service. `null` appears on
 * `AppInstallationRecord` for legacy rows with no matching credential.
 */
export type AppRole = 'read' | 'write';

/**
 * Maps each FOSSA app onto its vcs-service GitHub App role.
 */
export const VCS_APP_ROLE = {
  fossabot: 'write',
  fossaCore: 'read',
} as const satisfies Record<string, AppRole>;

export type VcsApp = keyof typeof VCS_APP_ROLE;
